<template>
  <a-card :bordered="false">
    <a-table bordered :data-source="form.goods_sku" :columns="columns" :pagination='false'>
      <template #imageUrl="{ record }">
        <div>
          <div class='ant-upload-list ant-upload-list-picture-card' >
            <div class='ant-upload-list-picture-card-container'>
              <span>
                <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                  <div class="ant-upload-list-item-info">
                    <img :src="info.picdomain+'/'+record.product_image" class='ant-upload-list-item-image' v-if="record.product_image" />
                    <img :src="info.picdomain+form.product_image" class='ant-upload-list-item-image' />
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import { ref } from "@vue/reactivity";
import store from "@/store";
import { onMounted } from '@vue/runtime-core';
import {
  getGoodsDetail,
} from "@/api/online";
export default {
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  
  setup(props) {
      const form = ref(JSON.parse(JSON.stringify({})));
    const columns = ref([
      {
        title: "规格图片",
        dataIndex: "imageUrl",
        slots: { customRender: "imageUrl" },
      },
      {
        title: "价格(元)",
        dataIndex: "product_price",
        key: "product_price",
      },

      {
        title: "单件支付积分",
        dataIndex: "point_price",
        key: "point_price",
      },
      {
        title: "整箱支付积分",
        dataIndex: "box_point_price",
        key: "box_point_price",
      },
      {
        title: "商品编号",
        dataIndex: "product_sku_sn",
        key: "product_sku_sn",
        customRender:({record})=>{
            return record.product_sku_sn?record.product_sku_sn:form.value.product_sn
        }
      },
    ]);
    const initData=async ()=>{
      let result=await  getGoodsDetail(props.options.goods_id).then(res=>res.data).catch(error=>error)
          form.value = result.data;
               //  多规格组装表头
          if (form.value.spec_type == 2) {
            var spec_value = form.value.spec_value;
            var column = [];
            spec_value.forEach((element, k) => {
              column.push({
                title: element.spec_name,
                dataIndex: "skus",
                customRender: ({ record }) => {
                  return record.product_spec_value.split("-")[k];
                },
              });
            });
            columns.value = column.concat(columns.value);
            // 规格生成字段
            form.value.product_sku.map((v) => {
              v["box_point_price"] = null;
              v["point_price"] = null;
              v["sku"] = v.sku_sn;
            });
          }
    }
    onMounted(()=>{
     initData()
    })
    return {
      columns,
      info: store.state.user.info,
      product_sku:[],
      form

    };
  },
};
</script>